import { DirectiveOptions, DirectiveFunction } from 'vue'

const bind: DirectiveFunction = (el: HTMLElement) => {
  el.querySelectorAll('.v-input__icon button').forEach(x =>
    x.setAttribute('tabindex', '-1')
  )
}

export const DisabledIconFocus: DirectiveOptions = {
  bind
}
